import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(axios)
Vue.use(VueAxios)
export default {
  install(Vue) {
    Vue.prototype.$weeklySubscriberApiService = {
      weekly_subscriber_api_url: `${process.env.VUE_APP_MEMBER_API_URL}/weekly-subscribers`,
      weekly_subscriber_api_token: process.env.VUE_APP_MEMBER_API_TOKEN,
      
      /**
       * 新增電子報訂閱者
       * @param {*} data 
       * @returns 
       */
      async create(data) {
        try {
          const response = await axios.post(
            `${this.weekly_subscriber_api_url}`,
            data,
            { headers: { Authorization: `Bearer ${this.weekly_subscriber_api_token}` } }
          );
          
          return response.data.data && Object.keys(response.data.data).length > 0
            ? response.data
            : null;
        } catch (error) {
          console.error('Error creating weekly subscriber:', error);
          return null;
        }
      },

      /**
       * 透過電子郵件刪除電子報訂閱者
       * @param {*} email 
       * @returns 
       */
      async deleteByEmail(email) {
        try {
          const response = await axios.delete(
            `${this.weekly_subscriber_api_url}/${email}`,
            { headers: { Authorization: `Bearer ${this.weekly_subscriber_api_token}` } }
          );
          
          return response.data;
        } catch (error) {
          console.error(`Error deleting weekly subscriber with email ${email}:`, error);
          return null;
        }
      }
    }
  }
}
